// extracted by mini-css-extract-plugin
module.exports = {"header":"Pre_header__33UQ7","pre":"Pre_pre__3XCIb","normal":"Pre_normal__1q8SD","break":"Pre_break__GwYTO"};